import AutoSubmit from "@stimulus-components/auto-submit"

export class Controller extends AutoSubmit {
  static targets = [...super.targets, "submit"]

  connect() {
    super.connect()
    this.hideSubmitButton()
  }

  hideSubmitButton() {
    this.submitTarget.classList.add("md:hidden")
  }
}
